import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { KazButtonComponent } from '../kaz-button/kaz-button.component';

@Component({
    selector: 'kaz-card-category-hint',
    templateUrl: './card-category-hint.component.html',
    styleUrls: ['./card-category-hint.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FaIconComponent, KazButtonComponent]
})
export class CardCategoryHintComponent {
  showHint: boolean = true;
  @Output() closeHintOnEmit = new EventEmitter();
  @Input() category: 'CAR' | 'PROPERTY' | 'JOB' | 'NONE' = 'NONE';

  constructor() {
  }

  closeHintInfo() {
    this.showHint = false;
    this.closeHintOnEmit.emit();
  }

}
